// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__wiDWH","content":"LayoutSettings_content__Qx5ec"};